import { API_BASE_URL } from './index';
import { getToken, getUser } from './auth';

export const historialEstrategiasApi = {
  getHistorialEstrategias: async () => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/historial-estrategias`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load historial estrategias' }));
      throw new Error(error.error || 'Failed to load historial estrategias');
    }

    return response.json();
  },

  getHistorialEstrategia: async (id) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/historial-estrategias/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load historial estrategia' }));
      throw new Error(error.error || 'Failed to load historial estrategia');
    }

    return response.json();
  },
};

